import { FormattedMessage } from 'react-intl';
import { PoolTypography } from '@synergy/components';
import { SettingsItem } from '@synergy/admin/app-settings/ui';
import { Stack } from '@mui/material';
import { clearCache, systemCacheRequestingSelector, useAppDispatch } from '@synergy/admin/app-settings/data-access';
import { useSelector } from 'react-redux';

export const SystemCache = () => {
    const dispatch = useAppDispatch();
    const isRequesting = useSelector(systemCacheRequestingSelector);

    return (
        <SettingsItem
            action={<FormattedMessage id="app.settings.system.emptyCache.action" />}
            disabled={isRequesting}
            onClick={() => dispatch(clearCache())}
        >
            <Stack gap={0.5}>
                <PoolTypography
                    component="span"
                    typography="body1"
                    id="app.settings.system.emptyCache"
                    sx={{ fontWeight: 600 }}
                />
                <PoolTypography component="span" typography="body2" id="app.settings.system.emptyCache.description" />
                <PoolTypography component="span" typography="body2" color="grey.800">
                    <FormattedMessage id="app.settings.system.emptyCache.hint" />
                </PoolTypography>
            </Stack>
        </SettingsItem>
    );
};
